/* eslint-disable no-unused-vars */
/* eslint-disable no-lone-blocks */
import {
  Box,
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import logo from "../../Images/KYABRS.png";
import { red } from "@mui/material/colors";
import moment from "moment";
import profile from "../../Images/profile.png";
import girl from "../../Images/girl.png";
import "./pdf.css";
import {
  InputContainer,
  InputLevel,
  PidDiv,
  PidDiv1,
  RegisterDiv,
} from "./Volunteer.style";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const tableCellStyle = {
  border: "1px solid #000000",
  textAlign: "left",
  padding: "2px",
  paddingLeft: ".5rem",
};
const tableCellStyle4 = {
  border: "1px solid #000000",
  textAlign: "left",
  padding: "2px",
  paddingLeft: ".5rem",
  width: "160px",
};

const tableCellStyle1 = {
  border: "1px solid #000000",
  textAlign: "left",
  padding: "2px",
  paddingLeft: ".5rem",
  fontWeight: 800,
};

const tableCellStyle2 = {
  border: "1px solid #000000",
  textAlign: "left",
  padding: "2px",
  paddingLeft: ".5rem",
  fontWeight: 600,
  width: "200px",
};
const tableCellStyle3 = {
  border: "1px solid #000000",
  textAlign: "left",
  padding: "2px",
  paddingLeft: ".5rem",
  width: "50%",
};

const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const currentDate = new Date();

  let ageYears = currentDate.getFullYear() - birthDate.getFullYear();
  let ageMonths = currentDate.getMonth() - birthDate.getMonth();
  let ageDays = currentDate.getDate() - birthDate.getDate();

  if (ageDays < 0) {
    const lastMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 1,
      birthDate.getDate()
    );
    ageMonths = currentDate.getMonth() - lastMonth.getMonth();
    ageDays = currentDate.getDate() - lastMonth.getDate();
  }

  let ageString = "";

  if (ageYears > 0) {
    ageString += `${ageYears} ${
      ageYears === 0 || ageYears === 1 ? "Year" : "Years"
    }`;
  }

  return ageString;
};
const PdfVolProfile = ({ volunteerData, history }) => {
  const pid = volunteerData?.vol_id !== "";
  const femaleStatus = volunteerData?.sex;
  const healthCondition =
    volunteerData?.health_condition === "undefined" ||
    volunteerData?.health_condition === "" ||
    volunteerData?.health_condition === null
      ? "N"
      : "Y";
  const previousIllness =
    volunteerData?.previous_illness === "undefined" ||
    volunteerData?.previous_illness === "" ||
    volunteerData?.previous_illness === null
      ? "N"
      : "Y";
  const surgeryHistory =
    volunteerData?.surgery_history === "undefined" ||
    volunteerData?.surgery_history === "" ||
    volunteerData?.surgery_history === null
      ? "N"
      : "Y";
  const allergie =
    volunteerData?.allergies === "undefined" ||
    volunteerData?.allergies === "" ||
    volunteerData?.allergies === null
      ? "N"
      : "Y";
  const currMedication =
    volunteerData?.curr_medication === "undefined" ||
    volunteerData?.curr_medication === "" ||
    volunteerData?.curr_medication === null
      ? "N"
      : "Y";
  const previousClinicTrial =
    volunteerData?.previous_clinic_trial === "undefined" ||
    volunteerData?.previous_clinic_trial === "" ||
    volunteerData?.previous_clinic_trial === null ||
    volunteerData?.previous_clinic_trial === "N"
      ? "N"
      : "Y";
  const availabilitys =
    volunteerData?.availability === "undefined" ||
    volunteerData?.availability === "" ||
    volunteerData?.availability === null ||
    volunteerData?.availability === "N"
      ? "N"
      : "Y";

  const covidImage = volunteerData?.covid_image ? "Y" : "N";
  const fathrHusbNidImage = volunteerData?.fathr_or_husb_nid_image ? "Y" : "N";
  const voluntaryNidImage = volunteerData?.voluntary_nid_image ? "Y" : "N";
  const voluntaryNid = volunteerData?.national_id ? "Y" : "N";
  const nidCheck = voluntaryNidImage || voluntaryNid ? "Y" : "N";
  const voluntaryImage = volunteerData?.voluntary_image ? "Y" : "N";
  const [maleChecked, setMaleChecked] = useState(volunteerData?.sex === "Male");

  const footerDate = volunteerData.created_at;
  const newDate = new Date();
  const formattedDate = moment(newDate).format("D-MMM-yyyy");
  const formattedTime = moment(newDate).format("HH:mm:ss");
  const footerFormattedDate = moment(footerDate).format("D-MMM-yyyy");
  const footerFormattedTime = moment(footerDate).format("HH:mm:ss");
  const footerUpdateFormattedDate = moment(volunteerData?.updated_at).format(
    "D-MMM-yyyy"
  );
  const footerUpdateFormattedTime = moment(volunteerData?.updated_at).format(
    "HH:mm:ss"
  );

  const [femaleChecked, setFemaleChecked] = useState(
    volunteerData?.sex === "Female"
  );

  const handleMaleChange = () => {
    setMaleChecked(!maleChecked);
    setFemaleChecked(false);
  };

  const handleFemaleChange = () => {
    setFemaleChecked(!femaleChecked);
    setMaleChecked(false);
  };

  const [pageNumber, setPageNumber] = useState(2);
  const [totalPages, setTotalPages] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    const calculateTotalPages = () => {
      const container = document.createElement("div");

      container.appendChild(contentRef.current.cloneNode(true));
      document.body.appendChild(container);
      const windowHeight = window.innerHeight;
      const contentHeight = container.offsetHeight;
      const pages = Math.ceil(contentHeight / windowHeight);
      document.body.removeChild(container);
      setTotalPages(pages);
    };

    calculateTotalPages();

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const contentHeight = contentRef.current.offsetHeight;
      const scrollPosition = Math.ceil(
        (scrollTop + windowHeight) / contentHeight
      );
      setPageNumber(Math.min(scrollPosition, totalPages));
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [totalPages]);

  return (
    <>
      <div className="pdf-container">
        <div className="header">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginLeft: "32px",
              marginRight: "32px",
            }}
          >
            <p>{formattedDate}</p>
            <p>KYAMCH BIO-RESEARCH SERVICES</p>
            <p>{formattedTime}</p>
          </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginLeft: "32px",
              marginRight: "32px",
              marginTop: "12px",
            }}
          >
            <Typography
              variant="h5"
              style={{
                textDecoration: "underline",
                textAlign: "center",
                fontWeight: "bold",
                font: "18px",
                marginTop: ".50rem",
                marginBottom: ".50rem",
              }}
            >
              VOLUNTEER INFORMATION SHEET
            </Typography>
            <img style={{ height: "rem", width: "8rem" }} src={logo} alt="" />
          </Box>
        </div>

        <div ref={contentRef} className="content">
          {volunteerData?.sex === "Female" && (
            <>
              {" "}
              <div className="content" style={{ marginTop: "4.5rem" }}>
                <div style={{ height: "100%" }}>
                  <Box sx={{ width: "100%" }}>
                    <Table style={tableStyle}>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle1}>
                            PID Number
                          </TableCell>
                          <TableCell style={tableCellStyle1}>
                            <PidDiv1>{volunteerData?.vol_id}</PidDiv1>
                          </TableCell>
                        </TableRow>

                        <TableRow style={tableCellStyle1}>
                          <TableCell style={tableCellStyle1}>
                            Old Volunteers ID
                          </TableCell>
                          <TableCell style={tableCellStyle1}>
                            {volunteerData?.old_vol_id}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle1}>
                            Hospital Registration No.
                          </TableCell>
                          <TableCell style={tableCellStyle1}>
                            {volunteerData?.reg_no}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>

                  <Grid container spacing={4} sx={{ mt: 1 }}>
                    <Grid item xs={8}>
                      <Box sx={{ width: "100%" }}>
                        <Box
                          style={{
                            borderTop: "1px solid black",
                            borderLeft: "1px solid black",
                            borderRight: "1px solid black",
                            padding: ".25rem",
                            fontWeight: "bold",
                          }}
                        >
                          Personal Information
                        </Box>

                        <Table style={tableStyle}>
                          <TableHead>
                            <TableRow>
                              {/* <TableCell style={tableCellStyle}>Company</TableCell>
                    <TableCell style={tableCellStyle}>Contact</TableCell>
                    <TableCell style={tableCellStyle}>Country</TableCell> */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Name
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.full_name}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Initial
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.vol_initial?.length === 1 && (
                                  <>--{volunteerData?.vol_initial}</>
                                )}
                                {volunteerData?.vol_initial?.length === 2 && (
                                  <>-{volunteerData?.vol_initial}</>
                                )}
                                {volunteerData?.vol_initial?.length === 3 && (
                                  <>{volunteerData?.vol_initial}</>
                                )}
                                {volunteerData?.vol_initial?.length > 3 && (
                                  <>
                                    {volunteerData?.vol_initial?.substring(
                                      0,
                                      3
                                    )}
                                  </>
                                )}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Father's Name
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.father_name}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Mother's Name
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.mother_name}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Date of Birth
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {moment(volunteerData?.dob).format(
                                  "DD MMM YYYY"
                                )}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>Age</TableCell>
                              <TableCell style={tableCellStyle}>
                                {calculateAge(volunteerData?.dob)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>Sex</TableCell>
                              <TableCell style={tableCellStyle}>
                                <label>
                                  <Checkbox
                                    checked={maleChecked}
                                    onChange={handleMaleChange}
                                    inputProps={{ "aria-label": "Male" }}
                                  />
                                  Male
                                </label>
                                <label>
                                  <Checkbox
                                    checked={femaleChecked}
                                    onChange={handleFemaleChange}
                                    inputProps={{ "aria-label": "Female" }}
                                  />
                                  Female
                                </label>
                              </TableCell>
                            </TableRow>

                            {femaleStatus === "Female" && (
                              <TableRow>
                                <TableCell style={tableCellStyle2}>
                                  Father/Husband Name:
                                </TableCell>
                                <TableCell style={tableCellStyle}>
                                  {volunteerData?.v_fathr_or_husb_name}
                                </TableCell>
                              </TableRow>
                            )}
                            {femaleStatus === "Female" && (
                              <TableRow>
                                <TableCell style={tableCellStyle2}>
                                  Father/Husband NID:
                                </TableCell>
                                <TableCell style={tableCellStyle}>
                                  {volunteerData?.fathr_or_husb_nid}
                                </TableCell>
                              </TableRow>
                            )}
                            
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Blood Group
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.vol_blood_group}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Nationality
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.nationality}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Occupation
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.occupation_name}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>NID</TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.national_id}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box sx={{ ml: "1rem" }}>
                        <Box>
                          {" "}
                          {femaleStatus === "Female" && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                style={{
                                  height: "125px",
                                  wight: "auto",
                                }}
                                src={volunteerData?.voluntary_image || girl}
                                alt=""
                              />
                            </div>
                          )}
                          {femaleStatus === "Male" && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                style={{
                                  height: "125px",
                                  wight: "auto",
                                }}
                                src={volunteerData?.voluntary_image || profile}
                                alt=""
                              />
                            </div>
                          )}
                          {femaleStatus === "Others" && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                style={{
                                  height: "125px",
                                  wight: "auto",
                                }}
                                src={volunteerData?.voluntary_image || profile}
                                alt=""
                              />
                            </div>
                          )}
                        </Box>
                        <Box sx={{ mt: 1 }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              border: "1px solid black",
                            }}
                          >
                            <div>Date of Registration</div>
                            <div style={{ fontWeight: 600 }}>
                              {moment(
                                volunteerData?.date_of_registration
                              ).format("DD MMM YYYY")}
                            </div>
                          </div>
                        </Box>
                        <Box sx={{ mt: 2 }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              border: "1px solid black",
                            }}
                          >
                            <div>Status</div>
                            <div style={{ fontWeight: 600 }}>
                              {volunteerData?.active_fg === 1
                                ? "Active"
                                : "Inactive"}
                            </div>
                          </div>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>

                  <Box sx={{ width: "100%", mt: 1 }}>
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Contact Details
                    </Box>

                    <Table style={tableStyle}>
                      <TableHead>
                        <TableRow>
                          {/* <TableCell style={tableCellStyle}>Company</TableCell>
                    <TableCell style={tableCellStyle}>Contact</TableCell>
                    <TableCell style={tableCellStyle}>Country</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Contact Number
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.contact_phone}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Emergency Contact Person:
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.emergency_contract_nm}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Emergency Contact number
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.emergency_contract_ph}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Relationship with volunteers
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.contact_contract_relation}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                  <Box sx={{ width: "100%", mt: 1 }}>
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Present Address
                    </Box>
                    <Table style={tableStyle}>
                      <TableHead>
                        <TableRow>
                          {/* <TableCell style={tableCellStyle}>Company</TableCell>
                <TableCell style={tableCellStyle}>Contact</TableCell>
                <TableCell style={tableCellStyle}>Country</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>Village</TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.village_name}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>Post</TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.permanent_postoffice}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Police Station
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.thana_name}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            District
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.permanent_district_name}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Division
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.pr_city_name}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </div>

                <div style={{ height: "100%" }}>
                  <div style={{ marginTop: "7rem" }}>.</div>
                  <Box
                    style={{ marginTop: "5.5rem" }}
                    sx={{ width: "100%", mt: 4 }}
                  >
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Medical history
                    </Box>

                    <Table style={tableStyle}>
                      <TableHead>
                        <TableRow>
                          {/* <TableCell style={tableCellStyle}>Company</TableCell>
                    <TableCell style={tableCellStyle}>Contact</TableCell>
                    <TableCell style={tableCellStyle}>Country</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Any relevant health conditions
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={healthCondition === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={healthCondition === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.health_condition === "undefined"
                              ? ""
                              : volunteerData.health_condition}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Previous illnesses
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={previousIllness === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={previousIllness === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.previous_illness === "undefined"
                              ? ""
                              : volunteerData.previous_illness}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Surgeries
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={surgeryHistory === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={surgeryHistory === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.surgery_history === "undefined"
                              ? ""
                              : volunteerData.surgery_history}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Allergies
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={allergie === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={allergie === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.allergies === "undefined"
                              ? ""
                              : volunteerData.allergies}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Current medications
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={currMedication === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={currMedication === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.curr_medication === "undefined"
                              ? ""
                              : volunteerData.curr_medication}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                  <Box sx={{ width: "100%", mt: 1 }}>
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Availability
                    </Box>

                    <Table style={tableStyle}>
                      <TableHead>
                        <TableRow>
                          {/* <TableCell style={tableCellStyle}>Company</TableCell>
                    <TableCell style={tableCellStyle}>Contact</TableCell>
                    <TableCell style={tableCellStyle}>Country</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Availability for participation in clinical trials
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={availabilitys === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={availabilitys === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Have you previously participated in clinical trials?{" "}
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={previousClinicTrial === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={previousClinicTrial === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.pre_clin_trial_detail === "undefined"
                              ? ""
                              : volunteerData.pre_clin_trial_detail}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>

                  <Box sx={{ width: "100%", mt: 1 }}>
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Attach
                    </Box>
                    <Table style={tableStyle}>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            NID card/Birth certificate
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={nidCheck === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={nidCheck === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Passport size photo
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={voluntaryImage === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={voluntaryImage === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            COVID-19 vaccine card.
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={covidImage === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={covidImage === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Father/ Husband NID
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={fathrHusbNidImage === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={fathrHusbNidImage === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>

                  {history?.length > 0 && (
                    <Box sx={{ width: "100%", mt: 1 }}>
                      <Box
                        style={{
                          borderTop: "1px solid black",
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          padding: ".25rem",
                        }}
                        sx={{ mt: 1, fontWeight: 700 }}
                      >
                        History
                      </Box>
                      <Table style={tableStyle}>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              style={tableCellStyle}
                              sx={{ fontWeight: 700 }}
                            >
                              Sl No
                            </TableCell>
                            <TableCell
                              style={tableCellStyle}
                              sx={{ fontWeight: 700 }}
                            >
                              Study Code
                            </TableCell>
                            <TableCell
                              style={tableCellStyle}
                              sx={{ fontWeight: 700 }}
                            >
                              Date of Last IMP intake
                            </TableCell>
                            <TableCell
                              style={tableCellStyle}
                              sx={{ fontWeight: 700 }}
                            >
                              Remarks
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        {history?.map((history, index) => {
                          return (
                            <TableBody key={index}>
                              <TableRow>
                                <TableCell style={tableCellStyle} size="small">
                                  {index + 1}
                                </TableCell>
                                <TableCell style={tableCellStyle} size="small">
                                  {history.study_code}
                                </TableCell>
                                <TableCell style={tableCellStyle} size="small">
                                  {moment(history.complet_date).format(
                                    "DD MMM YYYY"
                                  )}
                                </TableCell>
                                <TableCell style={tableCellStyle} size="small">
                                  {history.remarks}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          );
                        })}
                      </Table>
                    </Box>
                  )}
                </div>
              </div>
            </>
          )}
          {volunteerData?.sex === "Male" && (
            <>
              {" "}
              <div className="content" style={{ marginTop: "5.5rem" }}>
                <div style={{ height: "100%" }}>
                  <Box sx={{ width: "100%" }}>
                    <Table style={tableStyle}>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle1}>
                            PID Number
                          </TableCell>
                          <TableCell style={tableCellStyle1}>
                            <PidDiv1>{volunteerData?.vol_id}</PidDiv1>
                          </TableCell>
                        </TableRow>

                        <TableRow style={tableCellStyle1}>
                          <TableCell style={tableCellStyle1}>
                            Old Volunteers ID
                          </TableCell>
                          <TableCell style={tableCellStyle1}>
                            {volunteerData?.old_vol_id}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle1}>
                            Hospital Registration No.
                          </TableCell>
                          <TableCell style={tableCellStyle1}>
                            {volunteerData?.reg_no}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>

                  <Grid container spacing={4} sx={{ mt: 1 }}>
                    <Grid item xs={8}>
                      <Box sx={{ width: "100%" }}>
                        <Box
                          style={{
                            borderTop: "1px solid black",
                            borderLeft: "1px solid black",
                            borderRight: "1px solid black",
                            padding: ".25rem",
                            fontWeight: "bold",
                          }}
                        >
                          Personal Information
                        </Box>

                        <Table style={tableStyle}>
                          <TableHead>
                            <TableRow>
                              {/* <TableCell style={tableCellStyle}>Company</TableCell>
                    <TableCell style={tableCellStyle}>Contact</TableCell>
                    <TableCell style={tableCellStyle}>Country</TableCell> */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Name
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.full_name}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Initial
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.vol_initial?.length === 1 && (
                                  <>--{volunteerData?.vol_initial}</>
                                )}
                                {volunteerData?.vol_initial?.length === 2 && (
                                  <>-{volunteerData?.vol_initial}</>
                                )}
                                {volunteerData?.vol_initial?.length === 3 && (
                                  <>{volunteerData?.vol_initial}</>
                                )}
                                {volunteerData?.vol_initial?.length > 3 && (
                                  <>
                                    {volunteerData?.vol_initial?.substring(
                                      0,
                                      3
                                    )}
                                  </>
                                )}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Father's Name
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.father_name}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Mother's Name
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.mother_name}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Date of Birth
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {moment(volunteerData?.dob).format(
                                  "DD MMM YYYY"
                                )}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>Age</TableCell>
                              <TableCell style={tableCellStyle}>
                                {calculateAge(volunteerData?.dob)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>Sex</TableCell>
                              <TableCell style={tableCellStyle}>
                                <label>
                                  <Checkbox
                                    checked={maleChecked}
                                    onChange={handleMaleChange}
                                    inputProps={{ "aria-label": "Male" }}
                                  />
                                  Male
                                </label>
                                <label>
                                  <Checkbox
                                    checked={femaleChecked}
                                    onChange={handleFemaleChange}
                                    inputProps={{ "aria-label": "Female" }}
                                  />
                                  Female
                                </label>
                              </TableCell>
                            </TableRow>

                            {femaleStatus === "Female" && (
                              <TableRow>
                                <TableCell style={tableCellStyle2}>
                                  Father/Husband Name:
                                </TableCell>
                                <TableCell style={tableCellStyle}>
                                  {volunteerData?.v_fathr_or_husb_name}
                                </TableCell>
                              </TableRow>
                            )}
                            {femaleStatus === "Female" && (
                              <TableRow>
                                <TableCell style={tableCellStyle2}>
                                  Father/Husband NID:
                                </TableCell>
                                <TableCell style={tableCellStyle}>
                                  {volunteerData?.fathr_or_husb_nid}
                                </TableCell>
                              </TableRow>
                            )}

                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Blood Group
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.vol_blood_group}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Nationality
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.nationality}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>
                                Occupation
                              </TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.occupation_name}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={tableCellStyle2}>NID</TableCell>
                              <TableCell style={tableCellStyle}>
                                {volunteerData?.national_id}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box sx={{ ml: "1rem" }}>
                        <Box>
                          {" "}
                          {femaleStatus === "Female" && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                style={{
                                  height: "125px",
                                  wight: "auto",
                                }}
                                src={volunteerData?.voluntary_image || girl}
                                alt=""
                              />
                            </div>
                          )}
                          {femaleStatus === "Male" && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                style={{
                                  height: "125px",
                                  wight: "auto",
                                }}
                                src={volunteerData?.voluntary_image || profile}
                                alt=""
                              />
                            </div>
                          )}
                          {femaleStatus === "Others" && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                style={{
                                  height: "125px",
                                  wight: "auto",
                                }}
                                src={volunteerData?.voluntary_image || profile}
                                alt=""
                              />
                            </div>
                          )}
                        </Box>
                        <Box sx={{ mt: 1 }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              border: "1px solid black",
                            }}
                          >
                            <div>Date of Registration</div>
                            <div style={{ fontWeight: 600 }}>
                              {moment(
                                volunteerData?.date_of_registration
                              ).format("DD MMM YYYY")}
                            </div>
                          </div>
                        </Box>
                        <Box sx={{ mt: 2 }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              border: "1px solid black",
                            }}
                          >
                            <div>Status</div>
                            <div style={{ fontWeight: 600 }}>
                              {volunteerData?.active_fg === 1
                                ? "Active"
                                : "Inactive"}
                            </div>
                          </div>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>

                  <Box sx={{ width: "100%", mt: 1 }}>
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Contact Details
                    </Box>

                    <Table style={tableStyle}>
                      <TableHead>
                        <TableRow>
                          {/* <TableCell style={tableCellStyle}>Company</TableCell>
                    <TableCell style={tableCellStyle}>Contact</TableCell>
                    <TableCell style={tableCellStyle}>Country</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Contact Number
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.contact_phone}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Emergency Contact Person:
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.emergency_contract_nm}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Emergency Contact number
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.emergency_contract_ph}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Relationship with volunteers
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.contact_contract_relation}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                  <Box sx={{ width: "100%", mt: 1 }}>
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Present Address
                    </Box>
                    <Table style={tableStyle}>
                      <TableHead>
                        <TableRow>
                          {/* <TableCell style={tableCellStyle}>Company</TableCell>
                <TableCell style={tableCellStyle}>Contact</TableCell>
                <TableCell style={tableCellStyle}>Country</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>Village</TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.village_name}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>Post</TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.permanent_postoffice}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Police Station
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.thana_name}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            District
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.permanent_district_name}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Division
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData?.pr_city_name}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </div>

                <div style={{ height: "100%" }}>
                  <div style={{ marginTop: "15rem" }}>.</div>
                  <Box
                    style={{ marginTop: "5.5rem" }}
                    sx={{ width: "100%", mt: 4 }}
                  >
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Medical history
                    </Box>

                    <Table style={tableStyle}>
                      <TableHead>
                        <TableRow>
                          {/* <TableCell style={tableCellStyle}>Company</TableCell>
                    <TableCell style={tableCellStyle}>Contact</TableCell>
                    <TableCell style={tableCellStyle}>Country</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Any relevant health conditions
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={healthCondition === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={healthCondition === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.health_condition === "undefined"
                              ? ""
                              : volunteerData.health_condition}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Previous illnesses
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={previousIllness === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={previousIllness === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.previous_illness === "undefined"
                              ? ""
                              : volunteerData.previous_illness}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Surgeries
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={surgeryHistory === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={surgeryHistory === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.surgery_history === "undefined"
                              ? ""
                              : volunteerData.surgery_history}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Allergies
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={allergie === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={allergie === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.allergies === "undefined"
                              ? ""
                              : volunteerData.allergies}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Current medications
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={currMedication === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={currMedication === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.curr_medication === "undefined"
                              ? ""
                              : volunteerData.curr_medication}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                  <Box sx={{ width: "100%", mt: 1 }}>
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Availability
                    </Box>

                    <Table style={tableStyle}>
                      <TableHead>
                        <TableRow>
                          {/* <TableCell style={tableCellStyle}>Company</TableCell>
                    <TableCell style={tableCellStyle}>Contact</TableCell>
                    <TableCell style={tableCellStyle}>Country</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Availability for participation in clinical trials
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={availabilitys === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={availabilitys === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Have you previously participated in clinical trials?{" "}
                          </TableCell>
                          <TableCell style={tableCellStyle4}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={previousClinicTrial === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={previousClinicTrial === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            {volunteerData.pre_clin_trial_detail === "undefined"
                              ? ""
                              : volunteerData.pre_clin_trial_detail}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>

                  <Box sx={{ width: "100%", mt: 1 }}>
                    <Box
                      style={{
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        padding: ".25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Attach
                    </Box>
                    <Table style={tableStyle}>
                      <TableBody>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            NID card/Birth certificate
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={nidCheck === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={nidCheck === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Passport size photo
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={voluntaryImage === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={voluntaryImage === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            COVID-19 vaccine card.
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={covidImage === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={covidImage === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell style={tableCellStyle2}>
                            Father/ Husband NID
                          </TableCell>
                          <TableCell style={tableCellStyle}>
                            <div>
                              <label>
                                <Checkbox
                                  checked={fathrHusbNidImage === "Y"}
                                  inputProps={{ "aria-label": "Yes" }}
                                />
                                Yes
                              </label>
                              <label>
                                <Checkbox
                                  checked={fathrHusbNidImage === "N"}
                                  inputProps={{ "aria-label": "No" }}
                                />
                                No
                              </label>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>

                  {history?.length > 0 && (
                    <Box sx={{ width: "100%", mt: 1 }}>
                      <Box
                        style={{
                          borderTop: "1px solid black",
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          padding: ".25rem",
                        }}
                        sx={{ mt: 1, fontWeight: 700 }}
                      >
                        History
                      </Box>
                      <Table style={tableStyle}>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              style={tableCellStyle}
                              sx={{ fontWeight: 700 }}
                            >
                              Sl No
                            </TableCell>
                            <TableCell
                              style={tableCellStyle}
                              sx={{ fontWeight: 700 }}
                            >
                              Study Code
                            </TableCell>
                            <TableCell
                              style={tableCellStyle}
                              sx={{ fontWeight: 700 }}
                            >
                              Date of Last IMP intake
                            </TableCell>
                            <TableCell
                              style={tableCellStyle}
                              sx={{ fontWeight: 700 }}
                            >
                              Remarks
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        {history?.map((history, index) => {
                          return (
                            <TableBody key={index}>
                              <TableRow>
                                <TableCell style={tableCellStyle} size="small">
                                  {index + 1}
                                </TableCell>
                                <TableCell style={tableCellStyle} size="small">
                                  {history.study_code}
                                </TableCell>
                                <TableCell style={tableCellStyle} size="small">
                                  {moment(history.complet_date).format(
                                    "DD MMM YYYY"
                                  )}
                                </TableCell>
                                <TableCell style={tableCellStyle} size="small">
                                  {history.remarks}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          );
                        })}
                      </Table>
                    </Box>
                  )}
                </div>
              </div>
            </>
          )}
        </div>

        {Array.from({ length: totalPages }).map((_, index) => (
          <div
            key={index}
            className="footer"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <p>KYAMCH BIO-RESEARCH SERVICES</p>
            {/* <p>Page {index } of {totalPages}</p> */}
            <p>Page 1 of 2</p>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {volunteerData?.updated_at?.length > 0 ? (
                <>
                  {moment(volunteerData?.updated_at).isValid() && (
                    <>
                      <p style={{ marginRight: "10px" }}>
                        {footerUpdateFormattedDate}
                      </p>
                      <p>{footerUpdateFormattedTime}</p>
                    </>
                  )}
                </>
              ) : (
                <>
                  {moment(footerDate).isValid() && (
                    <>
                      <p style={{ marginRight: "10px" }}>
                        {footerFormattedDate}
                      </p>
                      <p>{footerFormattedTime}</p>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PdfVolProfile;
